import modalConfirmation from '../../../shared/components/modal-response/modal-response.view.html';
let inject = [
  '$scope',
  'MyPaymentsListService',
  '$state',
  '$rootScope',
  'SharedService',
  '$uibModal',
  'NgTableParams'
];

class MyPaymentsListController{
  constructor ($scope, MyPaymentsListService, $state, $rootScope, SharedService, $uibModal, NgTableParams) {
    this.$state = $state;
    this.$scope = $scope;
    this.NgTableParams = NgTableParams;
    this.$rootScope = $rootScope;
    this.$uibModal = $uibModal;
    this.MyPaymentsListService = MyPaymentsListService;
    this.SharedService = SharedService;
    this.myPayments = {};
    this.totalPayed = 0;
    this.loandingPayments = false;
  }

  $onInit(){
    this.getDatas();
  }
  
  getDatas() {
    let documentNumber = '';
    try{
      documentNumber = this.shCtrl.globals.currentClient.third.id;
    }
    catch(e){
      documentNumber = this.shCtrl.globals.currentUser.thirdDocumentNumber;
    }
    this.loandingPayments = true;
    // this.MyPaymentsListService.getPeyments(documentNumber).then(response => {
    this.MyPaymentsListService.getPeyments('890328444').then(response => {
      this.payments = response;
      response.forEach(val => {
        if(!val.recaudo_total) val.recaudo_total = 0;
        else if(angular.isString(val.recaudo_total)) parseInt(val.recaudo_total);
        this.totalPayed += val.recaudo_total;
      });
      this.loandingPayments = false;
      this.initTable();
    }).catch((reason) => {
      this.loandingPayments = false;
    });
  }
  
  initTable() {
    this.ngTableColsPayList = [
      {
        field: "fecha_creacion",
        title: "Fecha",
        sortable: "fecha_creacion",
        filter: { "fecha_creacion": "text" },
        show: true
      },
      {
        field: "id",
        title: "Pago",
        sortable: "id",
        filter: { "id": "text" },
        show: true
      },
      {
        field: "tercero_id",
        title: "Tercero",
        sortable: "tercero.nombre",
        filter: { "tercero.nombre": "text" },
        show: false
      },
      {
        field: "estado_pago",
        title: "Estado",
        sortable: "estado_pago",
        filter: { "estado_pago": "text" },
        show: true
      },
      {
        field: "recaudo_total",
        title: "Recaudo",
        sortable: "recaudo_total",
        filter: { "recaudo_total": "text" },
        show: true
      },
      {
        field: "actions",
        title: "Acciones",
        show: true
      }
    ];
    
    let initialParams = {
      count: 20,
      sorting: { fecha_creacion: "desc" }
    };
    
    let initialSettings = {
      counts: [5, 10, 20],
      paginationMaxBlocks: 8,
      paginationMinBlocks: 2,
      dataset: this.payments
    };
    
    this.ngTableConfigPayList = new this.NgTableParams(initialParams, initialSettings);
  }
  
  messageResponse (options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller : 'ModalResponseController',
      controllerAs : 'mdCtrl',
      size: options.size,
      resolve : {
        modalOptions : () => options
      }
    });
    modalInstance.result.then(() => {
      if(callAcept) {
        callback();
      }
    }).catch(reason => {
      if(callCancel) {
        callbackCancel();
      }
    });
  }
}

MyPaymentsListController.$inject = inject;

export default MyPaymentsListController;




// WEBPACK FOOTER //
// ./www/components/pay-zone/my-payments/my-payments-list/my-payments-list.controller.js